<script lang="ts" setup>
  import { computed } from 'vue';
  import Button from '../Button/Button.vue';
  import {
    actionsWrapperClass,
    centeredClass,
    centeredHeaderClass,
    centeredRowClass,
    centeredTextClass,
    headerContainerClass,
    headerLeftSectionClass,
    pageIntroClass,
    subtitleClass,
    titleClass,
    titleRowClass,
  } from './PageIntro.css';
  import type { PageIntroProps } from './PageIntro.types';

  const props = defineProps<PageIntroProps>();

  const rootClasses = computed(() => [
    pageIntroClass,
    props.centered ? centeredClass : null,
  ]);

  const headerClasses = computed(() => [
    headerContainerClass,
    props.centered ? centeredHeaderClass : null,
  ]);

  const sectionClasses = computed(() => [
    headerLeftSectionClass,
    props.centered ? centeredClass : null,
  ]);

  const titleRowClasses = computed(() => [
    titleRowClass,
    props.centered ? centeredRowClass : null,
  ]);

  const titleClasses = computed(() => [
    titleClass,
    props.centered ? centeredTextClass : null,
  ]);

  const subtitleClasses = computed(() => [
    subtitleClass,
    props.centered ? centeredTextClass : null,
  ]);

  const buttonActions = computed(() =>
    (props.actions ?? []).map(({ label, onClick, ...buttonProps }) => ({
      label,
      onClick,
      buttonProps,
    })),
  );
</script>

<template>
  <div :class="rootClasses">
    <slot v-if="$slots.topWidget" name="topWidget" />
    <slot v-if="$slots.stepper" name="stepper" />

    <div :class="headerClasses">
      <div :class="sectionClasses">
        <div :class="titleRowClasses">
          <slot name="prefixIconTitleSlot" />
          <slot name="title">
            <h1 v-if="title" :class="titleClasses">{{ title }}</h1>
          </slot>
        </div>

        <slot name="subtitle">
          <p v-if="subtitle" :class="subtitleClasses">{{ subtitle }}</p>
        </slot>

        <slot name="extraContent" />
      </div>

      <div
        v-if="$slots.actions || buttonActions.length"
        :class="actionsWrapperClass"
      >
        <slot name="actions">
          <Button
            v-for="(action, index) in buttonActions"
            :key="action.buttonProps.testId || `action-${index}`"
            v-bind="action.buttonProps"
            @click="action.onClick"
          >
            {{ action.label }}
          </Button>
        </slot>
      </div>
    </div>
  </div>
</template>
